import {AccountId} from '@raison/types';
import {OwnWalletResource} from '~/processes/crypto-send-and-receive';
import {selectAssetsResource} from '~/redux/assets/assetsResource';
import {useAppSelector} from '~/shared/store';

// Further extension allowed in case these hooks satisfy other dependencies
// This is useful because lsp feature "go to implementations" on OwnWalletResource
// leads here
interface WalletResource extends OwnWalletResource {}

export function useCryptoWalletResource(accountId: AccountId) {
    return useAppSelector(state =>
        selectAssetsResource(state).mapSuccess(({accounts}): WalletResource | undefined =>
            Object.values(accounts.crypto).find(acc => acc.id === accountId)
        )
    );
}
export function useTokenWalletResource(accountId: AccountId) {
    return useAppSelector(state =>
        selectAssetsResource(state).mapSuccess(({accounts}): WalletResource | undefined =>
            Object.values(accounts.tokens).find(acc => acc.id === accountId)
        )
    );
}
